import tpl_banner from './tpl_banner'
import tpl_title from './tpl_title'
import tpl_left_one_right_two from './tpl_left_one_right_two'
import tpl_left_two_right_one from './tpl_left_two_right_one'
import tpl_top_one_bottom_two from './tpl_top_one_bottom_two'
import tpl_top_two_bottom_one from './tpl_top_two_bottom_one'
import tpl_flex_one from './tpl_flex_one'
import tpl_flex_two from './tpl_flex_two'
import tpl_flex_three from './tpl_flex_three'
import tpl_flex_five from './tpl_flex_five'
import tpl_flex_four from './tpl_flex_four'
import tpl_text_picture from './tpl_text_picture'
import tpl_menu from './tpl_menu'
import tpl_search from './tpl_search'
import tpl_join_group from './tpl_join_group'
import tpl_integral from './tpl_integral'
import tpl_spike from './tpl_spike'
import tpl_group from './tpl_group'
import tpl_ad_list from './tpl_view_list'
import tpl_activity_list from './tpl_view_list'
import tpl_goods from './tpl_goods'
export default {
  carousel: tpl_banner,
  title: tpl_title,
  leftOneRightTwo: tpl_left_one_right_two,
  leftTwoRightOne: tpl_left_two_right_one,
  topOneBottomTwo: tpl_top_one_bottom_two,
  topTwoBottomOne: tpl_top_two_bottom_one,
  flexThree: tpl_flex_three,
  flexFive: tpl_flex_five,
  flexFour: tpl_flex_four,
  flexTwo: tpl_flex_two,
  textPicture: tpl_text_picture,
  menu: tpl_menu,
  search: tpl_search,
  joinGroup: tpl_join_group,
  flexOne: tpl_flex_one,
  goods: tpl_goods,
  integral: tpl_integral,
  spike: tpl_spike,
  group: tpl_group,
  tpl_ad_list,
  tpl_activity_list,
}
